import { type FC, type ComponentProps } from 'react';

import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient.ts';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './MessageBanner-style.scss';

const MessageBanner = dibsLazyClient(
    () => import(/* webpackChunkName: "MessageBanner" */ './MessageBanner.jsx')
);

export const MessageBannerLazy: FC<ComponentProps<typeof MessageBanner>> = props => {
    return (
        <ClientSuspense
            fallback={
                <div
                    className={classnames(
                        styles.bannerContainer,
                        dibsCss.flex,
                        dibsCss.itemsCenter,
                        dibsCss.h0,
                        dibsCss.relative,
                        dibsCss.overflowHidden
                    )}
                />
            }
        >
            <MessageBanner {...props} useGlobalFallbackMessage />
        </ClientSuspense>
    );
};
